module.exports = __webpack_public_path__ + "static/media/family.750a8c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/family.png
// module id = 1173
// module chunks = 0